document.addEventListener("DOMContentLoaded", function() {
  var workflows = document.querySelectorAll(".nsh-bep__workflow-steps");
  if (!workflows.length) return;
  workflows.forEach(function(stepsRow) {
    function reveal() {
      stepsRow.classList.add("is-visible");
    }
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(stepsRow);
    } else {
      reveal();
    }
    window.setTimeout(reveal, 2e3);
  });
});
